import Swiper from "swiper/bundle";


export function common() {
  //スムーススクロール
  const thisHeader = document.querySelector(".header");
  const scrollTarget = document.querySelectorAll('a[href^="#"]');
  // console.log(paginationsA);
  const paginations = Array.prototype.slice.call(scrollTarget, 0);
  paginations.forEach((pagination) => {
    pagination.addEventListener("click", (e) => {
      // console.log(e);
      e.preventDefault();
      const targetId = e.currentTarget.hash;
      // console.log(targetId);
      const target = document.querySelector(targetId);
      target.scrollIntoView({
        behavior: "smooth",
      });
    });
  });

  // topへ

  const pageTop = document.getElementById("pageTop");

  if (pageTop) {
    pageTop.addEventListener("click", () => {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    });
  }


  // humburger

  const humburger = document.getElementById("humb");
  const nav = document.querySelector(".nav");
  const navLink = document.querySelectorAll(".navLink");
  const humb = document.getElementById("humb");

  if (humburger) {
    humburger.addEventListener("click", () => {
      nav.classList.toggle("close");
      nav.classList.toggle("open");
      humb.classList.toggle("active");
    });
  }

  if (navLink) {
    navLink.forEach((link) => {
      link.addEventListener("click", () => {
        nav.classList.add("close");
        nav.classList.remove("open");
      });
    });
  }


  //intersection observer

  const iSObserversA = document.querySelectorAll('.iSObserver');
  const iSObservers = Array.prototype.slice.call(iSObserversA, 0);
  const optionsOb = {
    rootMargin: '-20% 0px',
  };

  const fadeIn = (target) => {
    target.classList.add('active');
  };

  const observeUse = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        fadeIn(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observeUse, optionsOb);
  iSObservers.forEach(iSObserver => {
    observer.observe(iSObserver);
  });



  // swiper
  document.querySelectorAll('.product__swipeArea').forEach((area) => {
    const thumb = area.querySelector('.product__sliderThumbnail');
    const main = area.querySelector('.product__slider');
    if (thumb && main) {
      const productSliderThumbnail = new Swiper(thumb, {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
          1024: {
            slidesPerView: 10,
            spaceBetween: 18,
          },
        },
      });
      new Swiper(main, {
        loop: true,
        thumbs: {
          swiper: productSliderThumbnail,
        },
      });
    }
  });

  const standardSwiper = new Swiper('.standard__swiper', {
    // Optional parameters
    // direction: 'vertical',
    // loop: true,
    slidesPerView: 1.2,
    spaceBetween: 25,
    breakpoints: {
      1024: {
        slidesPerView: 2.2,
        spaceBetween: 67,
      },
    },


    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  });

  const modalContSwiper = new Swiper('.modal__contSwiper', {
    // Optional parameters
    // direction: 'vertical',
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    // },
  });

  const swiperButtonPrev2 = document.querySelectorAll('.swiper-button-prev2');
  const swiperButtonNext2 = document.querySelectorAll('.swiper-button-next2');

  if (swiperButtonPrev2.length > 0) {
    swiperButtonPrev2.forEach((button) => {
      button.addEventListener('click', () => {
        console.log('click')
        button.parentNode.querySelector('.swiper-button-prev').click();
      });
    });
  }

  if (swiperButtonNext2.length > 0) {
    swiperButtonNext2.forEach((button) => {
      button.addEventListener('click', () => {
        console.log('click')
        button.parentNode.querySelector('.swiper-button-next').click();
      });
    });
  }




  const worksItem = document.querySelectorAll('.works__item');
  const moreBtn = document.getElementById('moreBtn');
  let currentItem = 4; // 最初に表示するアイテム数
  const itemsToShow = 4; // 「もっと見る」ボタンをクリックするたびに表示するアイテム数

  if (worksItem.length > currentItem) {
    worksItem.forEach((item, index) => {
      if (index >= currentItem) {
        item.style.display = 'none';
      }
    });
  } else {
    if (moreBtn) {
      moreBtn.style.display = 'none';
    }
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      const hiddenItems = Array.from(worksItem).filter(item => item.style.display === 'none');
      for (let i = 0; i < itemsToShow && i < hiddenItems.length; i++) {
        hiddenItems[i].style.display = 'block';
      }
      currentItem += itemsToShow;
      if (currentItem >= worksItem.length) {
        moreBtn.style.display = 'none';
      }
    });
  }



  const mv__catch = document.querySelector('.mvArea__catch');
  window.addEventListener("load", () => {
    mv__catch.classList.add('active');
  });

  // window.addEventListener('scroll', () => {
  //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //   if (scrollTop > 100) {
  //     thisHeader.classList.add('scrolled');
  //   } else {
  //     thisHeader.classList.remove('scrolled');
  //   }
  // });





}